export default __webpack_public_path__ + "static/media/bus.0401b9cd.png";